import { z } from 'zod';
import { INVALID_STATE_TRANSITION } from '../reason-codes.js';
import { ProblemError } from './problem.js';
export function defineStateMachine(definition) {
    const schema = z.enum(definition.states);
    const canTransition = (from, to) => definition.transitions[from].includes(to);
    return {
        ...definition,
        schema,
        canTransition,
        assertTransition(from, to) {
            if (!canTransition(from, to)) {
                throw new ProblemError(definition.invalidTransitionCode ?? INVALID_STATE_TRANSITION, {
                    detail: `${definition.name}: transición inválida ${from} → ${to}`,
                });
            }
        },
        nextStates: (from) => definition.transitions[from],
        isTerminal: (state) => definition.terminal.includes(state),
    };
}
//# sourceMappingURL=state-machine.js.map